// LegalTexts.js

export const privacyPolicyText = `Privacy Policy
Last Updated: 11/06/2026

This Privacy Policy explains how Fusion Tech Associates LLP ("Company", "we", "our", or "us") collects, uses, and protects information when you use SORTED ("Platform"), including our website, AI tools, expert consultation services, startup assistance services, and related features.

1. Information We Collect
We may collect information such as your name, email address, phone number, business details, documents uploaded on the Platform, payment information, and any information voluntarily provided by you. We may also collect device information, IP address, browser details, and usage data to improve our Services.

2. How We Use Your Information
We use your information to provide and improve our Services, facilitate expert consultations, process payments, verify documents, communicate with users, enhance platform security, and comply with legal obligations.

3. Expert Consultations
SORTED connects users with independent experts for guidance and consultation. Advice provided by experts is based on their individual knowledge and experience. Users are responsible for decisions made based on such consultations.

4. AI-Powered Services
The Platform may provide AI-generated suggestions, business ideas, document insights, and startup assistance. Such outputs are for informational purposes only and should not be considered legal, financial, tax, or professional advice.

5. Information Sharing
We do not sell your personal information. Information may be shared with trusted service providers, payment processors, experts involved in providing services, or government authorities where required by law.

6. Data Security
We take reasonable measures to protect your information from unauthorized access, misuse, or disclosure. However, no online system can guarantee complete security.

7. Data Retention
We retain information only for as long as necessary to provide our Services, comply with legal requirements, resolve disputes, and enforce our agreements.

8. Third-Party Services
The Platform may contain links to third-party websites or services. We are not responsible for their content, policies, or privacy practices.

9. Children's Privacy
SORTED is intended for users who are at least 13 years old. We do not knowingly collect personal information from children.

10. Changes to This Policy
We may update this Privacy Policy from time to time. Continued use of the Platform after any updates constitutes acceptance of the revised Policy.

11. Contact Us
For any questions regarding this Privacy Policy, please contact us at:
Fusion Tech Associates LLP
Email: contactus@fusionsolutions.in`;

export const termsOfServiceText = `Terms of Service
Last Updated: 11/06/2026

These Terms of Service ("Terms") govern your access to and use of SORTED ("Platform"), owned and operated by Fusion Tech Associates LLP ("Company", "we", "our", or "us").
By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, please do not use the Platform.

1. Use of the Platform
SORTED provides startup-related assistance, AI-powered tools, expert consultations, document support, and related services.
You agree not to:
- Use the Platform for any unlawful purpose.
- Upload false, misleading, or unauthorized information.
- Attempt to gain unauthorized access to the Platform or its systems.
- Disrupt, interfere with, or misuse the Platform.
- Copy, reproduce, or exploit any part of the Platform without permission.
We reserve the right to suspend or terminate access for violations of these Terms.

2. User Accounts
Certain features may require account registration.
You agree that:
- Information provided by you is accurate and up to date.
- You will maintain the confidentiality of your login credentials.
- You are responsible for activities conducted through your account.
- You will immediately notify us of any unauthorized access to your account.

3. Expert Consultation Services
SORTED acts solely as a technology platform connecting users with independent experts.
Experts provide guidance based on their individual knowledge and experience.
The Company does not guarantee the accuracy, completeness, or outcome of any consultation.
Users remain solely responsible for decisions made based on expert advice.
Consultation fees and availability are displayed through the Platform.

4. AI Services
The Platform may provide AI-generated recommendations, business ideas, document analysis, and startup assistance.
AI-generated content is provided for informational purposes only and should not be considered legal, financial, tax, investment, or professional advice. Users should independently verify important information before relying upon it.

5. Payments
Certain services on the Platform may require payment.
By purchasing a service, you agree to:
- Provide accurate payment information.
- Pay all applicable fees and charges.
- Authorize processing of payments through our designated payment partners.
All payments made through the Platform are subject to applicable taxes and payment gateway charges.

6. Refunds
Refunds may be considered on a case-by-case basis.
Generally, consultation fees, completed services, digital services, and services already availed are non-refundable. Any approved refund will be processed through the original payment method, subject to applicable deductions and processing timelines.

7. Intellectual Property
All content, software, trademarks, logos, designs, text, graphics, and materials available on the Platform are owned by or licensed to Fusion Tech Associates LLP.
You may not copy, modify, distribute, or commercially exploit any content without prior written consent.

8. Service Availability
We strive to provide uninterrupted access to the Platform; however, we do not guarantee that services will always be available, error-free, or uninterrupted.
We may modify, suspend, or discontinue any feature or service at any time.

9. Limitation of Liability
To the maximum extent permitted by law, Fusion Tech Associates LLP shall not be liable for any indirect, incidental, special, consequential, or business losses arising from the use of the Platform, expert consultations, or AI-generated content.

10. Third-Party Services
The Platform may contain links to or integrations with third-party services, payment gateways, or websites.
We are not responsible for their content, services, privacy practices, or terms.

11. Termination
We may suspend or terminate your access to the Platform at any time if:
- You violate these Terms.
- Your activities pose a risk to the Platform or its users.
- We are required to do so by law.
Upon termination, your right to access and use the Platform shall immediately cease.

12. Changes to Terms
We may update these Terms from time to time. Continued use of the Platform after any update constitutes acceptance of the revised Terms.

13. Governing Law
These Terms shall be governed by and construed in accordance with the laws of India.
Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts at Gurugram, Haryana.

14. Contact Us
For any questions regarding these Terms, please contact:
Fusion Tech Associates LLP
Email: contactus@fusionsolutions.in`;